export const ExclusiveDealsColorScheme = [
  {
    toColor: "rgba(203, 53, 54, 1)",
    fromColor: "rgba(252,176,69,1)",
  },
  {
    toColor: "rgba(206,191,0,1)",
    fromColor: "rgba(251,251,76,255)",
  },
  {
    toColor: "rgba(0,112,0,1)",
    fromColor: "rgba(0,251,108,1)",
  },
  {
    toColor: "rgba(0,33,148,1)",
    fromColor: "rgba(0,226,241,1)",
  },
];
